import { useLocation } from 'react-router';

export const useAuthLinksWithReturnUrl = (tracking?: string) => {
  const { pathname, search } = useLocation();

  // Use '?' if no search params exist, otherwise '&'
  const separator = search ? '&' : '?';
  const returnUrl = `${pathname}${search}${tracking ? `${separator}tracking=${tracking}` : ''}`;

  return {
    loginUrl: `/oauth/login/?returnUrl=${encodeURIComponent(returnUrl)}`,
    googleLoginUrl: `/oauth/login/?returnUrl=${encodeURIComponent(
      returnUrl,
    )}&strategy=google`,
    registerUrl: `/oauth/register/?returnUrl=${encodeURIComponent(returnUrl)}`,
  };
};
